import { Component } from "react";
import ListingWebServices from "../service/listing_web_services";
import ProposalServices from "../service/proposal_web_services";
import DataResult from "../data/bean/data_result";
import Config from "../Config";
import LanguageBloc from "./language_bloc";
import UtilBloc from "./util_bloc";
import moment from "moment";
import GeneralBloc from "./general_bloc";
import QuotationService from "../service/quotation_web_service";
import FormsBloc from "./forms_bloc";
import ProposalBloc from "./mrtt_proposal_bloc";

class QuotationBloc extends Component {

  static async getListingCountData(
    id,
    entity,
    dateFilter,
    fromDate,
    toDate,
    sourceChannel
  ) {
    let condition = [
      {
        entity: entity,
        field: "trxTimestamp",
        value: fromDate,
        type: ">",
      },
      {
        entity: entity,
        field: "trxTimestamp",
        value: toDate,
        type: "<",
      },
    ];

    let payload = {};

    payload = {
      userId: id,
      dateCondition: condition,
      sourceChannel: sourceChannel
    }

    let response = await QuotationService.getQuotationCount(payload);

    return response;
  }

  static async getListingData(
    id,
    entity,
    sortCriteria,
    sortOrder,
    fromDate,
    toDate,
    status,
    page,
    keyword,
    sourceChannel
  ) {
    let condition = [];
    if (status === 'ALL') {
      condition = [
        {
          entity: entity,
          field: "trxTimestamp",
          value: fromDate,
          type: ">",
        },
        {
          entity: entity,
          field: "trxTimestamp",
          value: toDate,
          type: "<",
        },
      ];
    } else {
      condition = [
        {
          entity: entity,
          field: "trxTimestamp",
          value: fromDate,
          type: ">",
        },
        {
          entity: entity,
          field: "trxTimestamp",
          value: toDate,
          type: "<",
        },
        {
          entity: entity,
          field: "trxStatus",
          value: status,
          type: "=",
        },
      ]
    }


    let payload = {};

    payload = {
      userId: id,
      page: page,
      keyword: keyword,
      sortField: sortCriteria,
      sortBy: sortOrder,
      condition: condition,
      sourceChannel: sourceChannel
    }
    console.log('payload', payload)
    let response = await QuotationService.getQuotationList(payload);
    return await this.getProposalDetailByQuotation(response);
  }
  static async getProposalDetailByQuotation(data) {
    let quotationListing = data;
    if (quotationListing.success && quotationListing.data) {
      if (quotationListing.data?.length > 0) {
        await Promise.all(quotationListing.data.map(async (element, idx) => {
          if (element.quotation.trxStatus == Config.quotation.statusMapping.GENERATED.label) {
            let proposalStatus = await ProposalBloc.getProposalByQuotationId(element.quotation.id);
            quotationListing.data[idx].quotation.proposalDetail = proposalStatus;
          }
        }));
      }
    }
    return quotationListing;
  }

  static async getProposalDetailByGeneratedStatus(quotationData) {
    let item = '';
    let data = [];
    quotationData.forEach(async element => {
      if (element.quotation.trxStatus == Config.quotation.statusMapping.GENERATED.label) {
        let proposalStatus = await ProposalBloc.getProposalByQuotationId(element.quotation.id);
        item = {
          quotation: element.quotation,
          quotation_attr: element.quotation_attr,
          proposal: proposalStatus
        }
      } else {
        item = element
      }
      return item;
    })
    console.log(8);
    return data;
  }

  static async deleteQuotationById(id) {
    let resp = await QuotationService.deleteQuotationById(id);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getUpdateQuotationDetails(id, quotationId) {
    let payload = {
      userId: id
    };
    let response = await QuotationService.updateQuotationDetails(payload, quotationId);

    return response;
  }

  static async generateQuotation(quotationId) {
    let response = await QuotationService.generateQuotation(quotationId);
    return response;
  }

  static async getQuotationDetail(quotationId, id) {
    let payload = {
      id: quotationId,
      userId: id
    };
    let result = {};
    try {
      let response = await QuotationService.generateQuotationData(payload);
      if (response.success) {
        result = this.mapQuotationDetail(response);
      }
      return result;
    } catch (error) {
      let resp = error;
      return new DataResult(false, resp.message);
    }
  }

  static async getGenerateBase64Document(docId) {
    let payload = {
      id: docId
    };

    let response = await QuotationService.generateQuotationDocument(payload);
    return response;
  }

  static async getLoanTermListing(dob, defermentPeriod, bankId) {
    let payload = {
      dob: dob,
      defermentPeriod: defermentPeriod,
      sourceChannel: bankId
    };

    let response = await QuotationService.getLoanTermListing(payload);
    return response;
  }

  static async mapQuotationDetail(response) {
    let generatedDocument = [];
    // Getting Generated Documents
    await response.data?.uploaded_document.data.forEach((item) => {
      let record = {};
      record = {
        caption: item.uploaded_document.properties.filename,
        value: item.uploaded_document.id,
        size: item.uploaded_document.properties.sizeMB,
        type: item.uploaded_document.properties.format,
      };
      generatedDocument.push(record);
    });

    const indexOfPersonalDetails = await response.data.attributes.data.findIndex(
      (item) => item.quotation_attr.category === "PERSONAL_DETAILS"
    );

    const indexOfFinancialDetails = await response.data.attributes.data.findIndex(
      (item) => item.quotation_attr.category === "FINANCING_DETAILS"
    );

    const indexOfTakafulDetails = await response.data.attributes.data.findIndex(
      (item) => item.quotation_attr.category === "TAKAFUL_DETAILS"
    );

    let personalDetailsAttr =
      indexOfPersonalDetails !== -1
        ? response.data.attributes.data[indexOfPersonalDetails]
        : null;

    let financialDetailsAttr =
      indexOfFinancialDetails !== -1
        ? response.data.attributes.data[indexOfFinancialDetails]
        : null;

    // console.log("check Financial", financialDetailsAttr);

    let takafulDetailsAttr =
      indexOfTakafulDetails !== -1
        ? response.data.attributes.data[indexOfTakafulDetails]
        : null;

    //console.log("check Takaful", takafulDetailsAttr);
    //Getting Quotation Details
    let data = null;
    if (
      response.data.attributes.data.length > 0 &&
      response.data.quotation.data[0]?.quotation
    ) {
      data = {
        status: response.data.quotation.data[0].quotation.trxStatus,
        refNo: response.data.quotation.data[0].quotation.refNo,
        personalDetails: {
          caption: 'Personal Details',
          name: {
            caption: 'Name',
            value: personalDetailsAttr?.quotation_attr?.properties?.name ?? "",
          },
          gender: {
            caption: 'Gender',
            value:
              personalDetailsAttr?.quotation_attr?.properties?.gender,
          },
          typeId: {
            caption: 'ID Type',
            value:
              personalDetailsAttr?.quotation_attr?.properties?.idType
                ?.code,
          },
          idNo: {
            caption: 'IC No.',
            value: personalDetailsAttr?.quotation_attr?.properties?.idNo || personalDetailsAttr?.quotation_attr?.properties?.otherIdNo,
          },
          addIDType: {
            caption: 'Additional ID Type',
            value: personalDetailsAttr?.quotation_attr?.properties?.addIDType === 'oldIcNo' ? 'Old IC No' :
              personalDetailsAttr?.quotation_attr?.properties?.addIDType === 'birthCertNo' ? 'Birth Certificate No' :
                personalDetailsAttr?.quotation_attr?.properties?.addIDType,
          },
          addId: {
            caption: personalDetailsAttr?.quotation_attr?.properties?.addIDType === 'oldIcNo' ? 'Old IC No' : 'Birth Certificate No',
            value: personalDetailsAttr?.quotation_attr?.properties?.addIDType === 'oldIcNo' ? personalDetailsAttr?.quotation_attr?.properties?.oldIcNo :
              personalDetailsAttr?.quotation_attr?.properties?.addIDType === 'birthCertNo' ? personalDetailsAttr?.quotation_attr?.properties?.birthCertNo :
                null
          },
          dob: {
            caption: 'Date of Birth',
            value: moment(personalDetailsAttr?.quotation_attr?.properties?.dob).format('DD/MM/YYYY'),
          },
          anb: {
            caption: 'Age Next Birth',
            value: personalDetailsAttr?.quotation_attr?.properties?.anb,
          },
          occupation: {
            caption: 'Occupation',
            value: personalDetailsAttr?.quotation_attr?.properties?.occupation ? await FormsBloc.getOccupationNameByCode(personalDetailsAttr?.quotation_attr?.properties?.occupation) : "",
          },
          natureOfBusiness: {
            caption: 'Nature of Business',
            value: personalDetailsAttr?.quotation_attr?.properties?.natureOfBusiness ? await FormsBloc.getNobNameByCode(personalDetailsAttr?.quotation_attr?.properties?.occupation, personalDetailsAttr?.quotation_attr?.properties?.natureOfBusiness) : "",
          },
          occupationGroupCode: {
            caption: 'Occupation Code',
            value:
              personalDetailsAttr?.quotation_attr?.properties?.occupationGroupCode
          },
          occupationClass: {
            caption: 'Occupation Class',
            value:
              personalDetailsAttr?.quotation_attr?.properties?.occupationClass
          },
          smokerStatus: {
            caption: 'Smoker Status',
            value: personalDetailsAttr?.quotation_attr?.properties?.smoker,
          },
          dateOfQuotation: {
            caption: 'Date of Quotation',
            value:
              moment(personalDetailsAttr?.quotation_attr?.properties?.quotationDate).format('DD/MM/YYYY'),
          },
        },
        financialDetails: {
          caption: 'Financing Details',
          sourceChannel: financialDetailsAttr?.quotation_attr?.properties?.sourceChannel || '',
          financingBank: {
            caption: 'Financing Institution',
            value:
              financialDetailsAttr?.quotation_attr?.properties?.financingBank,
          },
          financed: {
            caption: 'Financed',
            value:
              financialDetailsAttr?.quotation_attr?.properties?.financed,
          },
          paymentMethod: {
            caption: 'Payment Method',
            value:
              financialDetailsAttr?.quotation_attr?.properties?.paymentMethod,
          },
          profitRate: {
            caption: 'Profit Rate',
            value: financialDetailsAttr?.quotation_attr?.properties?.profitRate ? (financialDetailsAttr?.quotation_attr?.properties?.profitRate * 100).toFixed(0) : '',
            suffix: "%",
          },
          coveredFinancingAmount: {
            caption: 'Covered Financing Amount',
            value:
              financialDetailsAttr?.quotation_attr?.properties?.coveredFinancingAmount,
            // type: "number",
            // fixed: 3,
            prefix: "RM ",
          },
          loanTerm: {
            caption: 'Loan Term',
            value:
              financialDetailsAttr?.quotation_attr?.properties
                ?.loanTerm,
            type: "number",
            fixed: 2,
            suffix: "years",
          },
          defermentPeriod: {
            caption: 'Deferment Period',
            value:
              financialDetailsAttr?.quotation_attr?.properties?.defermentPeriod,
            // type: "number",
            // fixed: 0,
            suffix: 'years',
          },
          criticalIllnessProtection: {
            caption: 'Critical Illness Protection',
            value:
              financialDetailsAttr?.quotation_attr?.properties?.criticalIllnessProtection,
          },
          criticalIllnessBenefit: {
            caption: 'Critical Illness Benefit',
            value:
              financialDetailsAttr?.quotation_attr?.properties?.criticalIllnessBenefit * 100,
            type: "number",
            fixed: 2,
            suffix: "%",
          },
        },
        takafulDetails: {
          caption: 'Takaful Details',
          coverageTerm: {
            caption: 'Coverage Term',
            value:
              takafulDetailsAttr?.quotation_attr?.properties?.coverageTerm,
            suffix: 'years',
          },
          initialSumCovered: {
            caption: 'Initial Sum Covered',
            value:
              takafulDetailsAttr?.quotation_attr?.properties?.initialSumCovered,
            // type: "number",
            // fixed: 6,
            prefix: "RM ",
          },
          totalSingleContribution: {
            caption: 'Total Single Contribution (Inclusive of fixed wakalah fee)',
            value:
              takafulDetailsAttr?.quotation_attr?.properties
                ?.totalSingleContribution,
            prefix: "RM ",
          },
          criticalIllnessSumCovered: {
            caption: 'Critical Illness Sum Covered',
            value:
              takafulDetailsAttr?.quotation_attr?.properties?.criticalIllnessSumCovered || '',
            prefix: "RM ",
          },
        },
        generatedDocuments: {
          caption: 'Generated Documents',
          data: generatedDocument,
        },
        // Add new map for isEdit indicator
        isEdit: response.data.quotation.data[0].quotation?.isEdit,
      };
    }

    return data;
  }

  static async createNewQuotation(bankID) {
    let response = await QuotationService.newQuotation(bankID);
    console.log("create quotation api: ", response)
    if (response.success) {
      console.log("Successfully create quotation", response);
      return response.data[0].quotation.id;
    }
  }

  static async mapQuotationPersonalDetailForm(response) {
    let record = {};
    let formattedDateDob = "";
    let fomattedDateQuotation = "";
    //console.log("response data:", response);
    if (response.data.length > 0) {
      if (response.data[0].quotation_attr.properties.dob) {
        formattedDateDob =
          moment(response.data[0].quotation_attr.properties.dob, 'YYYY/MM/DD') ??
          "";

        fomattedDateQuotation =
          moment(response.data[0].quotation_attr.properties.quotationDate, 'YYYY/MM/DD') ?? "";
      }

      let idNo = response.data[0].quotation_attr.properties.idNo;
      record = {
        name: response.data[0].quotation_attr.properties.name ?? "",
        gender: response.data[0].quotation_attr.properties.gender ?? "",
        typeId: response.data[0].quotation_attr.properties.idType.code ?? "",
        // otherTypeId:
        //   response.data[0].quotation_attr.properties.otherTypeId ?? "",
        idNo: idNo ?? "",
        otherIdNo: response.data[0].quotation_attr.properties.otherIdNo ?? "",
        dob: formattedDateDob ?? "",
        anb: String(response.data[0].quotation_attr.properties.anb ?? ""),
        occupationClass: response.data[0].quotation_attr.properties.occupationClass ?? "",
        occupationCode: response.data[0].quotation_attr.properties.occupationGroupCode ?? "",
        occupation: response.data[0].quotation_attr.properties.occupation || "",
        natureOfBusiness: response.data[0].quotation_attr.properties.natureOfBusiness || "",
        smokerStatus: response.data[0].quotation_attr.properties.smoker ?? "",
        dateOfQuotation: fomattedDateQuotation ?? "",
        addIDType: response.data[0].quotation_attr.properties.addIDType ?? "",
        oldIcNo: response.data[0].quotation_attr.properties.oldIcNo ?? "",
        birthCertNo: response.data[0].quotation_attr.properties.birthCertNo ?? "",
        // privacyPolicyAgreement:
        //   response.data[0].quotation_attr.properties.privacyPolicyAgreement ??
        //   false,
      };
    }

    //console.log("RECORED", record);
    return record;
  }

  static mapQuotationFinancingDetailForm(response) {
    let financingData = response.data[0]?.quotation_attr.properties;
    let record = {};
    if (response.data.length > 0) {
      record = {
        financingBank:
          financingData.financingBank ?? "",
        financed:
          financingData.financed ?? "",
        financingAmount: financingData.financingAmount ?? "",
        profitRate:
          financingData.profitRate ?? "",
        loanTerm:
          financingData.loanTerm ?? "",
        defermentPeriod:
          financingData.defermentPeriod ?? "",
        coveredFinancingAmount:
          financingData.coveredFinancingAmount ?? "",
        criticalIllnessProtection:
          financingData.criticalIllnessProtection ?? "",
        criticalIllnessBenefit:
          financingData.criticalIllnessBenefit ?? "",
        financingReferenceNo:
          financingData.financingReferenceNo ?? "",
        paymentMethod:
          financingData.paymentMethod ?? "",
        // financingPeriod:
        //   response.data[0].quotation_attr.properties.financingPeriod ?? "",
        // defermentPeriod:
        //   response.data[0].quotation_attr.properties.defermentPeriod ?? "",
      };
    }
    return record;
  }

  static mapQuotationTakafulDetailForm(response) {
    let record = {};
    if (response.data.length > 0) {
      record = {
        termOfCoverage:
          response.data[0].quotation_attr.properties.termOfCoverage ?? "",
        initialSumCovered:
          response.data[0].quotation_attr.properties.initialSumCovered ?? "",
        contributionAmount:
          response.data[0].quotation_attr.properties.contributionAmount ?? "",
        contributionMode:
          response.data[0].quotation_attr.properties.contributionMode ?? "",
        // basicPremium: "22.0"
        // contributionType:
        //   response.data[0].quotation_attr.properties.contributionType ?? "",
      };
    }
    return record;
  }

  static async getFormDetailQuotation(id, category) {
    let result = {};
    let response = await QuotationService.getQuotation(id, category);
    //.log("data response", response);
    if (response.success) {
      switch (category) {
        case "PERSONAL_DETAILS":
          result = this.mapQuotationPersonalDetailForm(response);
          break;
        case "FINANCING_DETAILS":
          result = this.mapQuotationFinancingDetailForm(response);
          break;
        case "TAKAFUL_DETAILS":
          result = this.mapQuotationTakafulDetailForm(response);
          break;
        default:
          break;
      }
    }
    return result;
  }

  static async getCalculatedContributionAmount(quotatidId) {

    let resp = await QuotationService.calculateContributionAmount(quotatidId);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message)
    }

  }

  static async saveForm(id, category, payload) {
    /* if (category == "TAKAFUL_DETAILS") {
      // console.log("in?");
      payload.contributionMode = "Cash";
    } */

    let resp = await QuotationService.saveQuotation(id, category, payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async generateDocuments(id) {
    let resp = await QuotationService.generateDocuments(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static getProposalSubmissionUrl(proposalId) {
    return `/${Config.context}/${Config.routes.generic.proposal_provide_details}/${proposalId}`;
  }

  static async editGeneratedQuotation(quotationId) {
    try {
      let resp = await QuotationService.editGeneratedQuotation(quotationId);
      if (resp.success) {
        return new DataResult(true, resp.message, resp.data);
      } else {
        return new DataResult(false, resp.message);
      }
    } catch (error) {
      return new DataResult(false, error.response.data.message, error.response.data);
    }
  }

  static async checkIsDocumentUnderQuotation(quotationId) {
    try {
      let resp = await QuotationService.checkDocumentIsUnderQuotation(
        quotationId
      );
      return resp;
    } catch (error) { }
  }
}

export default QuotationBloc;
